import { faBullseyePointer } from '@fortawesome/pro-regular-svg-icons/faBullseyePointer';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { faHandPointer } from '@fortawesome/pro-regular-svg-icons/faHandPointer';
import { faCircleBolt } from '@fortawesome/pro-regular-svg-icons/faCircleBolt';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import config from 'config';

const DUMMY_PAGE = {
  name: 'Kontentino Demo',
  type: 1,
  logo: `${config.PUBLIC_URL}/icons/512.png`,
};

export const REACH_POSTS = [
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-01 13:55:01',
      text: 'Reports & Insights\n\nAfter publishing, measure what matters 📊. Create client-ready reports in minutes and track competitor performance.\n\n💡 Pro Tip: Automate reports to receive updated insights every month — no manual work needed.',
      type: 5,
      attachments: {
        cards: [
          {
            medium: {
              video: {
                src: '',
                thumbSrc: `${config.PUBLIC_URL}/assets/images/calendar_view.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'totalReachUnique',
        title: 'Reach',
        color: '#2146ec',
        name: 'post_total_reach_unique',
        queryParameter: 'METRICS_POST_TOTAL_REACH_UNIQUE',
        customSubMetrics: [
          {
            name: 'post_impressions_paid_unique',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic_unique',
            title: 'Organic',
          },
        ],
        value: '39',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-02 08:15:00',
      text: 'Time-Saving Workflows\n\nPlan weeks of content in minutes. Duplicate, assign, or send multiple posts for approval with just a couple of clicks.\n\n💡 Pro Tip: Use Time Savers for recurring workflows → save hours and free up time for strategy.',
      type: 4,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/reports_insights1.png`,
              },
            },
          },
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'totalReachUnique',
        title: 'Reach',
        color: '#2146ec',
        name: 'post_total_reach_unique',
        queryParameter: 'METRICS_POST_TOTAL_REACH_UNIQUE',
        customSubMetrics: [
          {
            name: 'post_impressions_paid_unique',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic_unique',
            title: 'Organic',
          },
        ],
        value: '27',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-06 10:38:56',
      text: 'Multi-Channel Posting & Duplication\n\nOne idea → many channels. Duplicate this post from IG to FB or LinkedIn in seconds, then tweak captions or hashtags.\n\n💡 Pro Tip: When working in Profile Groups, duplication across multiple profiles takes even fewer clicks - perfect for agencies.',
      type: 3,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/reports_insights2.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'reactions',
        title: 'Reactions',
        color: '#00C7E6',
        name: 'post_reactions_by_type_total',
        queryParameter: 'METRICS_POST_REACTIONS_BY_TYPE_TOTAL___SUM',
        value: '15',
      },
    ],
  },
];
export const CALCULATED_REACH_POSTS = [
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-01 13:55:01',
      text: 'Reports & Insights\n\nAfter publishing, measure what matters 📊. Create client-ready reports in minutes and track competitor performance.\n\n💡 Pro Tip: Automate reports to receive updated insights every month — no manual work needed.',
      type: 5,
      attachments: {
        cards: [
          {
            medium: {
              video: {
                src: '',
                thumbSrc: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'totalReachUnique',
        title: 'Reach',
        color: '#2146ec',
        name: 'post_total_reach_unique',
        queryParameter: 'METRICS_POST_TOTAL_REACH_UNIQUE',
        customSubMetrics: [
          {
            name: 'post_impressions_paid_unique',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic_unique',
            title: 'Organic',
          },
        ],
        value: '39',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-02 08:15:00',
      text: 'Time-Saving Workflows\n\nPlan weeks of content in minutes. Duplicate, assign, or send multiple posts for approval with just a couple of clicks.\n\n💡 Pro Tip: Use Time Savers for recurring workflows → save hours and free up time for strategy.',
      type: 4,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/reports_insights2.png`,
              },
            },
          },
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'totalReachUnique',
        title: 'Reach',
        color: '#2146ec',
        name: 'post_total_reach_unique',
        queryParameter: 'METRICS_POST_TOTAL_REACH_UNIQUE',
        customSubMetrics: [
          {
            name: 'post_impressions_paid_unique',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic_unique',
            title: 'Organic',
          },
        ],
        value: '27',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-06 10:38:56',
      text: 'Multi-Channel Posting & Duplication\n\nOne idea → many channels. Duplicate this post from IG to FB or LinkedIn in seconds, then tweak captions or hashtags.\n\n💡 Pro Tip: When working in Profile Groups, duplication across multiple profiles takes even fewer clicks - perfect for agencies.',
      type: 3,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/reports_insights1.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'reactions',
        title: 'Reactions',
        color: '#00C7E6',
        name: 'post_reactions_by_type_total',
        queryParameter: 'METRICS_POST_REACTIONS_BY_TYPE_TOTAL___SUM',
        value: '15',
      },
    ],
  },
];
export const IMPRESSIONS_POSTS = [
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-01 13:55:01',
      text: 'Reports & Insights\n\nAfter publishing, measure what matters 📊. Create client-ready reports in minutes and track competitor performance.\n\n💡 Pro Tip: Automate reports to receive updated insights every month — no manual work needed.',
      type: 5,
      attachments: {
        cards: [
          {
            medium: {
              video: {
                src: '',
                thumbSrc: `${config.PUBLIC_URL}/assets/images/reports_insights1.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'postImpressions',
        title: 'Impressions',
        color: '#8746FF',
        name: 'post_impressions',
        queryParameter: 'METRICS_POST_IMPRESSIONS',
        customSubMetrics: [
          {
            name: 'post_impressions_paid',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic',
            title: 'Organic',
          },
        ],
        value: '39',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-02 08:15:00',
      text: 'Time-Saving Workflows\n\nPlan weeks of content in minutes. Duplicate, assign, or send multiple posts for approval with just a couple of clicks.\n\n💡 Pro Tip: Use Time Savers for recurring workflows → save hours and free up time for strategy.',
      type: 4,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'postImpressions',
        title: 'Impressions',
        color: '#8746FF',
        name: 'post_impressions',
        queryParameter: 'METRICS_POST_IMPRESSIONS',
        customSubMetrics: [
          {
            name: 'post_impressions_paid',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic',
            title: 'Organic',
          },
        ],
        value: '27',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-13 06:19:09',
      text: 'AI Inspiration (Creativity Booster)\n\nStuck on copy? Click AI Content ✨ to generate ideas, hashtags, or draft posts tailored to your goals.\n\n💡 Pro Tip: Drop in a blog link or product page, and let AI suggest content based on it. Perfect for fighting idea fatigue.',
      type: 5,
      attachments: {
        cards: [
          {
            medium: {
              video: {
                src: '',
                thumbSrc: `${config.PUBLIC_URL}/assets/images/calendar_view.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'postImpressions',
        title: 'Impressions',
        color: '#8746FF',
        name: 'post_impressions',
        queryParameter: 'METRICS_POST_IMPRESSIONS',
        customSubMetrics: [
          {
            name: 'post_impressions_paid',
            title: 'Paid',
          },
          {
            name: 'post_impressions_organic',
            title: 'Organic',
          },
        ],
        value: '2',
      },
    ],
  },
];
export const REACTIONS_POSTS = [
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-06 10:42:19',
      text: 'Approvals & Feedback\n\nNeed sign-off before going live? Click Send for Approval and let teammates or clients review directly in Kontentino.\n\n💡 Pro Tip: Use the chat box on each post to centralize feedback - clients love this compared to endless email threads.',
      type: 5,
      attachments: {
        cards: [
          {
            medium: {
              video: {
                src: '',
                thumbSrc: `${config.PUBLIC_URL}/assets/images/ai_inspiration.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'reactions',
        title: 'Reactions',
        color: '#00C7E6',
        name: 'post_reactions_by_type_total',
        queryParameter: 'METRICS_POST_REACTIONS_BY_TYPE_TOTAL___SUM',
        value: '15',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-06 10:38:56',
      text: 'Multi-Channel Posting & Duplication\n\nOne idea → many channels. Duplicate this post from IG to FB or LinkedIn in seconds, then tweak captions or hashtags.\n\n💡 Pro Tip: When working in Profile Groups, duplication across multiple profiles takes even fewer clicks - perfect for agencies.',
      type: 3,
      attachments: {
        cards: [
          {
            medium: {
              image: {
                src: `${config.PUBLIC_URL}/assets/images/reports_insights2.png`,
              },
            },
          },
        ],
      },
    },
    metrics: [
      {
        key: 'reactions',
        title: 'Reactions',
        color: '#00C7E6',
        name: 'post_reactions_by_type_total',
        queryParameter: 'METRICS_POST_REACTIONS_BY_TYPE_TOTAL___SUM',
        value: '15',
      },
    ],
  },
  {
    post: {
      page: DUMMY_PAGE,
      createdAt: '2025-10-06 10:42:47',
      text: 'Multi-Channel Posting & Duplication\n\nOne idea → many channels. Duplicate this post from IG to FB or LinkedIn in seconds, then tweak captions or hashtags.\n\n💡 Pro Tip: When working in Profile Groups, duplication across multiple profiles takes even fewer clicks - perfect for agencies.',
      type: 1,
      attachments: {
        cards: [],
      },
    },
    metrics: [
      {
        key: 'reactions',
        title: 'Reactions',
        color: '#00C7E6',
        name: 'post_reactions_by_type_total',
        queryParameter: 'METRICS_POST_REACTIONS_BY_TYPE_TOTAL___SUM',
        value: '15',
      },
    ],
  },
];

export const DUMMY_STATISTICS = [
  {
    name: 'totalReachUnique',
    value: 59,
    title: 'Reach',
    color: '#2146ec',
    icon: faBullseyePointer,
  },
  {
    name: 'postImpressions',
    value: 59,
    title: 'Impressions',
    color: '#8746FF',
    icon: faEye,
  },
  {
    name: 'comments',
    value: 444,
    title: 'Comments',
    color: '#FFC400',
    icon: faComment,
  },
  {
    name: 'shares',
    value: 0,
    title: 'Shares',
    color: '#575FCF',
    icon: faShareNodes,
  },
  {
    name: 'postClicks',
    value: 2,
    title: 'Post clicks',
    color: '#4194A0',
    icon: faHandPointer,
  },
  {
    name: 'engagementRate',
    value: 755.93,
    title: 'Engagement rate',
    color: '#DE1C22',
    icon: faCircleBolt,
  },
  {
    name: 'videoAverageTimeWatched',
    value: 3606.25,
    title: 'Average time watched',
    color: '#D1308B',
    icon: faClock,
  },
  {
    name: 'videoViews',
    value: 7,
    title: 'Video views',
    color: '#5CC742',
    icon: faVideo,
  },
];
